import { useState } from 'react'
import { QrCode } from 'lucide-react'

import { Button } from '@/common/ui/button'

import type { CryptoInvoiceData } from '@/modules/crypto-invoices/type'
import GeneratePaymentModal from './GeneratePaymentModal'

interface GeneratePaymentButtonProps {
	invoice: CryptoInvoiceData
}

export default function GeneratePaymentButton({
	invoice,
}: GeneratePaymentButtonProps) {
	const [isOpen, setIsOpen] = useState(false)

	const hasWalletAddress = !!invoice.walletAddress

	// Only show button for CREATED, PENDING, and PROCESSING statuses
	// Hide for COMPLETED, MANUAL, FAILED, EXPIRED, CANCELED
	const allowedStatuses = ['CREATED', 'PENDING', 'PROCESSING']
	if (!allowedStatuses.includes(invoice.status)) {
		return <span className="text-sm text-muted-foreground">-</span>
	}

	return (
		<>
			<Button
				variant={hasWalletAddress ? 'default' : 'outline'}
				size="sm"
				onClick={() => setIsOpen(true)}
			>
				<QrCode className="mr-2 h-4 w-4" />
				{hasWalletAddress ? 'ดู QR Code' : 'ดำเนินการชำระเงิน'}
			</Button>
			<GeneratePaymentModal
				invoice={invoice}
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
			/>
		</>
	)
}
